import React from 'react';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
//import { ReactComponent as PendingAgIcon } from 'assets/icons/pending-ag-icon.svg';
import { CalendarEvent } from 'pages/Agenda/utils/eventUtils';
import {
  HeaderContent,
  HeaderTopRow,
  HeaderMeta,
  HeaderTitle,
  //StatusBadge,
  CloseButton,
  HeaderFields,
  HeaderField,
} from './styled';

interface ModalHeaderProps {
  event: CalendarEvent;
  isCompletedView: boolean;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ event, isCompletedView, onClose }) => {
  const isPendente = !isCompletedView;
  //const statusIcon = event.realizada ? '✓' : event.atrasada ? <PendingAgIcon width={11} height={11} /> : null;

  return (
    <>
      <HeaderContent isPendente={isPendente}>
        <HeaderTopRow>
          <HeaderMeta>
            {/* <StatusBadge atrasada={event.atrasada} realizada={event.realizada}>
              {statusIcon}
            </StatusBadge> */}
            <HeaderTitle isPendente={isPendente}>Plano: {event.aplicacao}</HeaderTitle>
          </HeaderMeta>
          <CloseButton onClick={onClose} aria-label="Fechar modal">
            <XIcon />
          </CloseButton>
        </HeaderTopRow>

        <HeaderFields>
          <HeaderField isPendente={isPendente}>
            <strong>Unidade:</strong> {event.title}
          </HeaderField>
          <HeaderField isPendente={isPendente}>
            <strong>Ambiente:</strong> {event.areaNome || '-'}
          </HeaderField>
          <HeaderField isPendente={isPendente}>
            <strong>Equipamento:</strong> {event.equipamento || '-'}
          </HeaderField>
          <HeaderField isPendente={isPendente}>
            <strong>
              {event.qtdAtividades} {event.qtdAtividades === 1 ? 'atividade' : 'atividades'}
            </strong>{' '}
            ({event.horasPrevistas})
          </HeaderField>
        </HeaderFields>
      </HeaderContent>
    </>
  );
};
